module.exports = {"relevanz":{"apiBaseProd":"https://api.hyj.mobi","apiBase":"https://api.hyj.mobi"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/settings.json
// module id = 61
// module chunks = 0